<script setup lang="ts">
import {
  MeasurementStatusDto,
  QaEquipmentCatalogDto,
  QaEquipmentRtSystemDto,
} from '@/api/generator';
import { computed } from 'vue';
import RTSystemPairRow from '../RTSystemTile/RTSystemPairRow.vue';
import Notification from '../notifications/Notification.vue';
import type { NotificationEntry } from '../notifications/types';

/**
 * The interface/array pair while a zero measurement runs on it: the bridge
 * badge (the start button, see the bridge slot, which is forwarded to the pair
 * row) stays on the bridge and shows the progress, particles flow out from
 * behind it into the interface while the zero measurement itself runs, and the
 * device's error messages are listed below the pair. Idle (no status) it is
 * the plain pair row.
 */
const props = defineProps<{
  /** The interface (slot 0) and its array (slot 1), in that order. */
  systems: (QaEquipmentRtSystemDto | QaEquipmentCatalogDto)[];
  status?: MeasurementStatusDto;
  notifications?: NotificationEntry[];
  dontShowDeviceState?: boolean;
}>();

// Particles flow only while the zero measurement itself runs, not while the
// device is still being prepared (Initializing).
const settling = computed(() => props.status?.measurementStatus === 'ZeroMeasuring');
</script>

<template>
  <div>
    <RTSystemPairRow
      :systems="systems"
      :dontShowDeviceState="dontShowDeviceState"
      :settling="settling"
    >
      <template v-if="$slots.bridge" #bridge>
        <slot name="bridge" />
      </template>
    </RTSystemPairRow>

    <div v-if="notifications?.length" class="d-flex flex-column w-100 mt-4">
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :value="notification"
        class="mb-2"
      />
    </div>
  </div>
</template>
